import React from "react";
import PropTypes from "prop-types";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Button, ConditionBox, DatePickerField } from "components";
import moment from "moment";

const ApdOtpayTxnCondition = (props) => {
  const { onClickSearch } = props;

  return (
    <>
      <ConditionBox>
        <Formik
          initialValues={{
            otpayDate: moment().add(-1, "days"),
          }}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            onClickSearch({
              otpayDate: moment(values.otpayDate).format("YYYYMMDD"),
            });
            setSubmitting(false);
          }}
          validationSchema={Yup.object().shape({
            otpayDate: Yup.date().required().nullable(),
          })}
        >
          {(props) => {
            const {
              values,
              isSubmitting,
              touched,
              errors,
              handleChange,
              handleSubmit,
            } = props;
            return (
              <Form onSubmit={handleSubmit}>
                <div className="HasTable">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          <dl>
                            <dt>
                              송금일<i></i>
                              <span>
                                {errors.otpayDate &&
                                  touched.otpayDate &&
                                  errors.otpayDate}
                              </span>
                            </dt>
                            <dd>
                              <div className="HasDate">
                                <DatePickerField
                                  name="otpayDate"
                                  date={values.otpayDate}
                                />
                              </div>
                            </dd>
                          </dl>
                        </td>
                        <td>
                          <Button
                            type="submit"
                            className="inquire"
                            disabled={isSubmitting}
                          >
                            조회하기
                          </Button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Form>
            );
          }}
        </Formik>
      </ConditionBox>
    </>
  );
};

ApdOtpayTxnCondition.propTypes = {};

export default ApdOtpayTxnCondition;
